module.exports = __webpack_public_path__ + "banquet/components/DownloadBanner/images/banquet_icon_120.53d2c7da08035213beea864784b4b84d.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/DownloadBanner/images/banquet_icon_120.png
// module id = 817
// module chunks = 0 1